(() => {
    const MODULE_NAME = 'category-card';
    const LABEL_SELECTOR = '.static-text.tbl-fixed-label';
    const CATEGORY_MODE_REGEX_PATTERN = '-cat$';

    /* Category card will rendered after this validation:
   * mode ends with "-cat" -> trigger the category ranker
   * source category exist
   * source category exist in the translation map in global config
   * only if all items equal to the source category
   * */

    const sendEvent = (channel, result) => {
        TRCImpl.sendAbTestEvent('category-card', `Channel: ${channel}, Result: ${result}`);
    };

    const setLabel = (internalc, categoryTranslation) => {
        const labelsNodes = internalc.querySelectorAll(LABEL_SELECTOR);
        const labels = Array.prototype.slice.call(labelsNodes);
        labels.forEach(label => {
            label.style.display = 'block';
            label.innerText = categoryTranslation.toUpperCase();
        });
    };

    const validateCategoryLogic = (myorigin, sourceCategory) => {
        let isValid = true;
        myorigin.boxes.forEach(box => {
            if (box.video_data && box.video_data.category) {
                if (sourceCategory !== box.video_data.category) {
                    sendEvent(sourceCategory, `fallback. item category is: ${box.video_data.category}`);
                    return isValid = false;
                }
            } else {
                sendEvent(sourceCategory, 'No Category');
                return isValid = false;
            }
        });

        isValid && sendEvent(sourceCategory, 'Success');
        return isValid;
    };

    const init = (internalc, myorigin, context) => {
        const module = TRC.CustomModulesManager.registeredModules[MODULE_NAME];
        const {options} = module;
        let showLabel = true;

        // mode ends with "-cat" -> trigger the category ranker
        const isCategoryCardMode = new RegExp(CATEGORY_MODE_REGEX_PATTERN).test(myorigin.mode);
        if (!isCategoryCardMode) {
            return;
        }

        // source category exist
        const sourceCategory = myorigin.globalTrcResponseJSON && myorigin.globalTrcResponseJSON.scat;
        const pubId = TRC && TRC.publisherId;
        const categoriesMap = TRCImpl.global['allowed-categories-map'];
        let allowedCategoriesMap = {};
        
        if (categoriesMap) {
            allowedCategoriesMap = categoriesMap[pubId] || categoriesMap;
        }
            
        if (!sourceCategory) {
            return sendEvent(sourceCategory, 'No Source Category');
        }

        // source category exist in the translation map in global config
        const categoryTranslation = allowedCategoriesMap[sourceCategory];
        if (!categoryTranslation) {
            return sendEvent(sourceCategory, 'No category translation');
        }

        // category card can be rendered with/without label depend on configuration
        if (options && options['hide-label']) {
            showLabel = false;
            sendEvent(sourceCategory, 'hidden label variant');

        }

        // let's be sure we are organic 
        const isOrganic = context.itemsTypes['is-organic'];
        if (isOrganic) {
            const isValid = validateCategoryLogic(myorigin, sourceCategory);

            if (showLabel && isValid) {
                setLabel(internalc, categoryTranslation);
            }
        }
    };

    TRC.customHooks[MODULE_NAME] = {
        hooks: {
            'list-suffix': function (internalc, myorigin, context) {
                init(internalc, myorigin, context);
            }
        }
    };
})();
